import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  ButtonToolbar,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { BookingTable, OverviewTable } from "./BookingTable";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  checkPermision,
  clearValues,
  formLabelsTheme,
  getValueType,
  iconError,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { red } from "@material-ui/core/colors";
// import { UserCreate } from "./UserCreate";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {
  fetchGroupCountry,
  fetchGroupPhoneType,
  fetchParameter,
  fetchParameter2,
} from "../businessParameter/businessParameterSlice";
import { fetchMenuTab, selectMenuTab } from "../menu/menuSlice";

import {
  fetchBooking,
  selectBooking,
  resetData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
} from "./bookingSlice";
import BootstrapTable from "react-bootstrap-table-next";
import { FormHelperText } from "@material-ui/core";
import { ModalClientRadio } from "./ModalClientRadio";
import { ModalPartyRadio } from "./ModalPartyRadio";
import { fetchParty } from "../party/partySlice";
import { fetchClient } from "../client/clientSlice";
import {
  addFilter,
  fetchFilter,
  removeFilter,
  selectFilter,
} from "../inbound/inboundSlice";
import { ModalLocationMasterRadio } from "./ModalLocationMasterRadio";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const BookingPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectBooking);
  const dataFilter = useSelector(selectFilter);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();
  const dataMenuTab = useSelector(selectMenuTab);

  // Filter
  const [value, setValue] = useState(0);
  const [force, setForce] = useState(false);

  const [filterName, setFilterName] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [tableDataFilter, setTableDataFilter] = useState([]);
  const [selected, setSelected] = useState(null);

  const [bookingStart, setBookingStart] = useState("");
  const [bookingEnd, setBookingEnd] = useState("");
  const [rsdStart, setRsdStart] = useState("");
  const [rsdEnd, setRsdEnd] = useState("");
  const [radStart, setRadStart] = useState("");
  const [radEnd, setRadEnd] = useState("");
  const [client, setClient] = useState("");
  const [consigne, setConsigne] = useState("");

  const [portOfLoading, setPortOfLoading] = useState("");
  const [portOfDischarge, setPortOfDischarge] = useState("");

  const [showClient, setShowClient] = useState(false);
  const [showShipper, setShowShipper] = useState(false);
  const [typeLocation, setTypeLocation] = useState("");
  const [showLocationMaster, setShowLocationMaster] = useState(false);
  const [getSearch, setGetSearch] = useState(false);

  // initial
  useEffect(() => {
    if (getSearch === true) {
      handleSearchFilter();
      setGetSearch(false);
    }
  }, [getSearch]);

  // initial
  const [formValues, setFormValues] = useState({
    name: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  const [formFilter, setFormFilter] = useState({
    client_name: {
      value: "",
      error: false,
      required: "N",
    },

    consignee_name: {
      value: "",
      error: false,
      required: "N",
    },
    port_of_loading: {
      value: "",
      error: false,
      required: "N",
    },
    port_of_loading_name: {
      value: "",
      error: false,
      required: "N",
    },
    port_of_discharge: {
      value: "",
      error: false,
      required: "N",
    },
    port_of_discharge_name: {
      value: "",
      error: false,
      required: "N",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load

      await dispatch(
        fetchBooking({
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      await dispatch(
        fetchClient({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      await dispatch(
        fetchParty({
          party_setting: "CONSIGNEE",
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      await dispatch(
        fetchFilter({
          object_code: "BOOKING",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setForce(false);
    }
  }, [force]);

  const handleSearch = async () => {
    if ((bookingStart && !bookingEnd) || (bookingEnd && !bookingStart)) {
      return showErrorDialog(
        "Please fill in both date filters: From Date and Until Date."
      );
    }
    if ((rsdStart && !rsdEnd) || (rsdEnd && !rsdStart)) {
      return showErrorDialog(
        "Please fill in both date filters: From Date and Until Date."
      );
    }
    if ((radStart && !radEnd) || (radEnd && !radStart)) {
      return showErrorDialog(
        "Please fill in both date filters: From Date and Until Date."
      );
    }
    let params = {
      pageNo: 1,
      pageSize: paginationSet,
      client: formFilter.client_name.value,
      consignee: formFilter.consignee_name.value,
      booking_start_date: bookingStart,
      booking_end_date: bookingEnd,
      rsd_start_date: rsdStart,
      rsd_end_date: rsdEnd,
      rad_start_date: radStart,
      rad_end_date: radEnd,
      // port_of_discharge: formFilter.port_of_discharge_name.value,
      // port_of_loading: formFilter.port_of_loading_name.value,
    };
    fields.forEach((item) => {
      params[item.params] = item.value;
    });

    try {
      const response = await dispatch(fetchBooking(params));
      console.log(response, "response");
      if (response.payload.data.status === 200) {
        console.log("if");
      } else {
        console.log("else");
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log("else");
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {
        pageNo: page,
        pageSize: sizePerPage,
        client: formFilter.client_name.value,
        consignee: formFilter.consignee_name.value,
        booking_start_date: bookingStart,
        booking_end_date: bookingEnd,
        rsd_start_date: rsdStart,
        rsd_end_date: rsdEnd,
        rad_start_date: radStart,
        rad_end_date: radEnd,
        // port_of_discharge: formFilter.port_of_discharge_name.value,
        // port_of_loading: formFilter.port_of_loading_name.value,
      };
      fields.forEach((item) => {
        params[item.params] = item.value;
      });

      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchBooking(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  // Parameter

  const [typeOptions, setTypeOptions] = useState([
    {
      id: "3",
      value: "booking_no",
      label: "Booking No.",
      show: "Y",
      editor: "text",
    },
    {
      id: "2",
      value: "vin",
      label: "VIN",
      show: "Y",
      editor: "text",
    },
    {
      id: "2",
      value: "von",
      label: "VON",
      show: "Y",
      editor: "text",
    },
    {
      id: "1",
      value: "dealer",
      label: "Dealer",
      show: "Y",
      editor: "text",
    },
  ]);
  // paket filter

  const [btnHide, setBtnHide] = useState(false);

  const data_filter = typeOptions.filter((element) => element.show === "Y");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  console.log(fields, "fields");

  function handleRemarkChange(i, event) {
    const values = [...fields];
    values[i].value = event.target.value;
    setFields(values);
  }

  function handleAdd(i, event) {
    const values = [...fields];

    if (values[i].params === "") {
      showDialog("Please select filter first");
    } else {
      // update disabled field
      values[i].add = "Y";
      values[i].remove = "Y";
      setFields(values);
      //   change status show

      const result = typeOptions.map((item) => {
        if (item.value === values[i].params) {
          return { ...item, show: "N" };
        }
        return item;
      });

      setTypeOptions(result);

      const filteredShow = result.filter((item) => item.show === "Y");
      if (filteredShow.length <= 1) {
        setBtnHide(true);
      } else {
        setBtnHide(false);
      }

      //   push new paramater
      values.push({
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      });
      setFields(values);
    }
  }

  function handleRemove(i) {
    const values = [...fields];

    const result = typeOptions.map((item) => {
      if (item.value === values[i].params) {
        return { ...item, show: "Y" };
      }
      return item;
    });

    setTypeOptions(result);

    const filteredShow = result.filter((item) => item.show === "Y");
    if (filteredShow.length >= 1) {
      setBtnHide(false);
    } else {
      setBtnHide(true);
    }

    values.splice(i, 1);
    setFields(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].params = event.value;
    values[i].id = event.id;
    values[i].editor = event.editor;
    values[i].label = event.label;
    setFields(values);
  };

  // paket filter bawah

  // Func Create
  const [show, setShow] = useState(false);
  const [showFilterSave, setShowFilterSave] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloseFilter = () => {
    setFilterName("");
    setFormValues({
      name: {
        value: "",
        error: false,
        required: "Y",
      },
    });
    setSelected(null);
    setShowFilter(false);
  };
  const handleCloseFilterSave = () => {
    setFormValues({
      name: {
        value: "",
        error: false,
        required: "Y",
      },
    });
    setShowFilterSave(false);
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleCreateFilter = async () => {
    if (!validatePost()) {
      return;
    }
    const details = {
      client: formFilter.client_name.value,
      consignee: formFilter.consignee_name.value,
      booking_start_date: bookingStart,
      booking_end_date: bookingEnd,
      rsd_start_date: rsdStart,
      rsd_end_date: rsdEnd,
      rad_start_date: radStart,
      rad_end_date: radEnd,
      // port_of_discharge: formFilter.port_of_discharge_name.value,
      // port_of_loading: formFilter.port_of_loading_name.value,
      booking_no: "",
      services_class: "",
      vin: "",
      von: "",
      dealer: "",
    };

    fields.forEach((item) => {
      // Check if the params exists as a property in the details object
      if (details.hasOwnProperty(item.params)) {
        details[item.params] = item.value;
      }
    });

    const params = {
      filter_name: formValues.name.value,
      object_code: "BOOKING",
      // filter_data: JSON.stringify(details),
      filter_data_object: details,
    };

    console.log(details, "params");
    try {
      const response = await dispatch(addFilter(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(
          fetchFilter({
            object_code: "BOOKING",
            pageNo: 1,
            pageSize: -1,
          })
        );
        setFormValues({
          name: {
            value: "",
            error: false,
            required: "Y",
          },
        });
        await handleCloseFilterSave();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleSearchFilter = async () => {
    let params = {
      filter_name: filterName,
    };

    params.object_code = "BOOKING";
    params.pageNo = 1;
    params.pageSize = -1;

    try {
      const response = await dispatch(fetchFilter(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleDelete = async (e, row) => {
    const params = { filter_id: `${row.filter_id}` };
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeFilter({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await dispatch(
            fetchFilter({
              object_code: "BOOKING",
              pageNo: 1,
              pageSize: -1,
            })
          );
          await handleSearchFilter();
          await handleCloseFilterSave();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
          >
            <div
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
              onClick={(e) => handleDelete(e, row)}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
              </span>
            </div>
          </OverlayTrigger>
        </div>
      </>
    );
  };

  const columnsFilter = [
    {
      text: "Name",
      dataField: "filter_name",
    },
    {
      text: "Action",
      dataField: "action",
      formatter: actionFormatter,
    },
  ];

  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelected(row.filter_data_object);
    },
  };
  const handleOk = (e) => {
    if (selected === null) {
      return showDialog("Please Select ...");
    }

    setFormFilter({
      ...formFilter,
      consignee_name: {
        value: selected.consignee,
        error: false,
        required: "N",
      },
      client_name: {
        value: selected.client,
        error: false,
        required: "N",
      },
      // port_of_discharge_name: {
      //   value: selected.port_of_discharge,
      //   error: false,
      //   required: "N",
      // },
      // port_of_loading_name: {
      //   value: selected.port_of_loading,
      //   error: false,
      //   required: "N",
      // },
    });

    setBookingStart(selected.booking_start_date);
    setBookingEnd(selected.booking_end_date);
    setRsdStart(selected.rsd_start_date);
    setRsdEnd(selected.rsd_end_date);
    setRadStart(selected.rad_start_date);
    setRadEnd(selected.rad_end_date);

    const initData = typeOptions
      .filter(
        (item) =>
          selected[item.value] !== undefined && selected[item.value] !== ""
      )
      .map((item, index, arr) => ({
        id: item.id,
        value: selected[item.value],
        params: item.value,
        label: item.label,
        add: "Y",
        editor: "text",
        remove: index === arr.length - 1 ? "N" : "Y",
      }));

    const data =
      initData.length > 0
        ? initData
        : [
            {
              id: "",
              value: "",
              params: "",
              label: "",
              add: "N",
              editor: "text",
              remove: "N",
            },
          ];

    setFields(data);
    handleCloseFilter();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const [fieldsFilter, setFieldsFilter] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  const handleRemoveFilter = () => {
    const initData = typeOptions.map((item) => {
      return {
        ...item,
        show: "Y",
      };
    });

    setTypeOptions(initData);
    // Buat salinan baru dari formFilter agar objek tidak terpengaruh langsung
    const newFormFilter = { ...formFilter };

    // Menggunakan clearValues untuk menghapus nilai pada newFormFilter
    clearValues(newFormFilter);

    console.log(newFormFilter, "newFormFilter");

    // Mengatur kembali state formFilter dengan objek yang telah diperbarui
    setFormFilter(newFormFilter);

    // Mengatur ulang state setFields dengan nilai yang diinginkan
    setFields([
      {
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      },
    ]);

    setBookingStart("");
    setBookingEnd("");
    setRsdStart("");
    setRsdEnd("");
    setRadStart("");
    setRadEnd("");
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            <Button
              className="btn btn-primary my-btn-primary-dark text-bold mb-5"
              onClick={(e) => history.push("/outbound/booking/create")}
            >
              Create New Booking{" "}
            </Button>
            <div className="mb-5">
              <ThemeProvider theme={formLabelsTheme}>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Client"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formFilter.client_name.value}
                          readOnly
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowClient(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formFilter.client_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormFilter({
                                ...formFilter,
                                ["client"]: {
                                  ...formFilter["client"],
                                  value: "",
                                },
                                ["client_name"]: {
                                  ...formFilter["client_name"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>

                    <Row>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="Booking Date From"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          onChange={(e) => setBookingStart(e.target.value)}
                          value={bookingStart}
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <p className="text-center mt-5">To</p>
                      </Col>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="Booking Date Until"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          onChange={(e) => setBookingEnd(e.target.value)}
                          value={bookingEnd}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="RSD From"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          onChange={(e) => setRsdStart(e.target.value)}
                          value={rsdStart}
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <p className="text-center mt-5">To</p>
                      </Col>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="RSD Until"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          onChange={(e) => setRsdEnd(e.target.value)}
                          value={rsdEnd}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Consignee"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formFilter.consignee_name.value}
                          readOnly
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowShipper(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formFilter.consignee_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormFilter({
                                ...formFilter,
                                ["consignee"]: {
                                  ...formFilter["consignee"],
                                  value: "",
                                },
                                ["consignee_name"]: {
                                  ...formFilter["consignee_name"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="RAD From"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          onChange={(e) => setRadStart(e.target.value)}
                          value={radStart}
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <p className="text-center mt-5">To</p>
                      </Col>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="RAD Until"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="job_date"
                          onChange={(e) => setRadEnd(e.target.value)}
                          value={radEnd}
                        />
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Port of Loading"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formFilter.port_of_loading_name.value}
                          readOnly
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setTypeLocation("loading");

                                setShowLocationMaster(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formFilter.port_of_loading_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormFilter({
                                ...formFilter,
                                ["port_of_loading"]: {
                                  ...formFilter["port_of_loading"],
                                  value: "",
                                },
                                ["port_of_loading_name"]: {
                                  ...formFilter["port_of_loading_name"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Port of Discharge"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formFilter.port_of_discharge_name.value}
                          readOnly
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setTypeLocation("discharge");
                                setShowLocationMaster(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formFilter.port_of_discharge_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormFilter({
                                ...formFilter,
                                ["port_of_discharge"]: {
                                  ...formFilter["port_of_discharge"],
                                  value: "",
                                },
                                ["port_of_discharge_name"]: {
                                  ...formFilter["port_of_discharge_name"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row> */}
                  </Col>
                </Row>
              </ThemeProvider>
            </div>

            {fields.map((field, idx) => {
              return (
                <div key={`${field}-${idx}`}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={2}>
                      {idx === 0 && <b>Advance Search</b>}
                    </Form.Label>

                    <Col sm={3}>
                      {fields[idx].add === "N" && (
                        <Select
                          // isClearable={true}
                          options={data_filter}
                          value={getValueType(field.params, typeOptions)}
                          placeholder="Select Field"
                          // onChange={handleTypeChange}
                          onChange={(e) => handleTypeChange(idx, e)}
                        />
                      )}
                      {fields[idx].add === "Y" && (
                        <Form.Control
                          type="text"
                          value={fields[idx].label}
                          disabled
                        />
                      )}
                    </Col>
                    <Col sm={3}>
                      {field.editor === "text" && (
                        <Form.Control
                          type="text"
                          placeholder="Enter text"
                          value={field.value || ""}
                          onChange={(e) => handleRemarkChange(idx, e)}
                        />
                      )}
                    </Col>
                    <Col sm={3} className=" m-0 p-0">
                      {fields[idx].remove === "Y" && (
                        <div
                          className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                          onClick={() => handleRemove(idx)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-light">
                            <SVG
                              src={toAbsoluteUrl("/media/svg/icons/New/X.svg")}
                            />
                          </span>
                        </div>
                      )}

                      {btnHide === false && fields.length - 1 === idx && (
                        <Button
                          className="mr-3"
                          variant="outline-primary"
                          onClick={(e) => handleAdd(idx, e)}
                        >
                          Add
                        </Button>
                      )}
                    </Col>
                  </Form.Group>
                </div>
              );
            })}

            <Row className="mt-6 justify-content-end">
              <OverlayTrigger
                overlay={<Tooltip id="products-edit-tooltip">Setting</Tooltip>}
              >
                <Button
                  className="mr-3"
                  onClick={(e) => {
                    setGetSearch(true);
                    setShowFilter(true);
                  }}
                >
                  {" "}
                  <span
                    className="svg-icon svg-icon-md svg-icon-light"
                    style={{ marginRight: "0px" }}
                  >
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/New/Setting.svg")}
                    />
                  </span>
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                overlay={<Tooltip id="products-edit-tooltip">Save</Tooltip>}
              >
                <Button
                  className="mr-3"
                  onClick={(e) => setShowFilterSave(true)}
                >
                  <span
                    className="svg-icon svg-icon-md svg-icon-light"
                    style={{ marginRight: "0px" }}
                  >
                    <SVG src={toAbsoluteUrl("/media/svg/icons/New/Save.svg")} />
                  </span>
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                overlay={<Tooltip id="products-edit-tooltip">Remove</Tooltip>}
              >
                <Button className="mr-3" onClick={handleRemoveFilter}>
                  <span
                    className="svg-icon svg-icon-md svg-icon-light"
                    style={{ marginRight: "0px" }}
                  >
                    <SVG src={toAbsoluteUrl("/media/svg/icons/New/X.svg")} />
                  </span>
                </Button>
              </OverlayTrigger>

              <Button
                className="mr-3 btn-filter"
                variant="primary"
                onClick={handleSearch}
              >
                Search
              </Button>
            </Row>

            <BookingTable
              data={data === null ? [] : data}
              page={pageNo}
              sizePerPage={pageSize}
              totalSize={totalRecord}
              onTableChange={handleTableChange}
              loading={loading}
              handleSearch={handleSearch}
            />
          </CardBody>
        </Card>
      </div>

      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showFilter}
        onHide={handleCloseFilter}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Saved Searching Parameter Setups
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Search By</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        setFilterName(e.target.value);
                      }}
                      value={filterName}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Col sm={6}>
                    <Button
                      className="btn btn-primary"
                      onClick={handleSearchFilter}
                    >
                      Search
                    </Button>
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            keyField="filter_id"
            data={dataFilter}
            columns={columnsFilter}
            hover
            selectRow={selectRow}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseFilter}>
            Close
          </Button>
          <Button variant="primary" onClick={handleOk}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showFilterSave}
        onHide={handleCloseFilterSave}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Save Search Parameter Setup
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <Row>
                  <Col xs={10} sm={3} md={11} lg={11}>
                    <RedditTextField
                      required
                      label="Name"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="name"
                      fullWidth
                      name="name"
                      value={formValues.name.value}
                      onChange={handleChange}
                      error={formValues.name.error}
                      helperText={
                        formValues.name.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseFilterSave}>
            Close
          </Button>
          <Button variant="primary" onClick={handleCreateFilter}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalClientRadio
        isOpen={showClient}
        setShow={setShowClient}
        setFormValues={setFormFilter}
        formValues={formFilter}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
      />

      <ModalPartyRadio
        isOpen={showShipper}
        setShow={setShowShipper}
        setFormValues={setFormFilter}
        formValues={formFilter}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
      />

      <ModalLocationMasterRadio
        isOpen={showLocationMaster}
        setShow={setShowLocationMaster}
        setFormValues={setFormFilter}
        formValues={formFilter}
        setFields={setFields}
        fields={fields}
        typeLocation={typeLocation}
        setTypeLocation={setTypeLocation}
      />
    </>
  );
};
